import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found-page',
  template: `
    <div class="stage">
      <div class="nf-card">
        <div class="nf-404">404</div>
        <div class="nf-t">Page Not Found</div>
        <p class="nf-p">The page you&rsquo;re looking for doesn&rsquo;t exist or may have moved.</p>
        <div class="nf-actions">
          <button class="btn-ghost" (click)="redirectToHome()">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 18l-6-6 6-6"/></svg>
            Go back
          </button>
          <a class="btn-primary" routerLink="/">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/></svg>
            Go to Home
          </a>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./not-found-page.component.scss'],
})
export class NotFoundPageComponent {

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.redirectIfUrlEmpty();
  }
  redirectToHome(): void {
    this.router.navigateByUrl('/home/customer');
  }

  redirectIfUrlEmpty(): void {
    if (window.location.pathname === '/' || window.location.pathname === '') {
      this.router.navigateByUrl('/home/customer');
    }
  }
}
